/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { all, fork } from 'redux-saga/effects';

import intentRootSaga from '@ibm-watson/shared/modules/actions/store/intents/sagas';
import workspacestateSaga from '@ibm-watson/shared/modules/actions/store/workspacestate/sagas';
import conflictsRootSaga from '@ibm-watson/shared/modules/dialog/store/conflicts/sagas';
import dialogRootSaga from '@ibm-watson/shared/modules/dialog/store/dialog/sagas';
import recommendationsRootSaga from '@ibm-watson/shared/modules/dialog/store/recommendations/sagas';
import planRootSaga from '@ibm-watson/shared/modules/ia/store/plan/sagas';
import sessionRootSaga from '@ibm-watson/shared/modules/ia/store/session/sagas';

export default function* rootSaga() {
  yield all([fork(sessionRootSaga), fork(planRootSaga)]);
  yield fork(recommendationsRootSaga);
  yield fork(dialogRootSaga);
  yield fork(intentRootSaga);
  yield fork(conflictsRootSaga);
  yield fork(workspacestateSaga);
}
